import { inject, Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '@services/util/util.service';

@Pipe({
  name: 'utilPipe',
  standalone: true
})
export class UtilPipe implements PipeTransform {

  private readonly util = inject(UtilService);

  transform(value: any, utilFunc: 'titleCaseFirstWord'|'titleCaseEveryWord'): any {

    switch (utilFunc) {
      case 'titleCaseFirstWord': return this.util.titleCaseFirstWord(value);
      case 'titleCaseEveryWord': return this.util.titleCaseEveryWord(value);
    }

    return 'incorrect util method';
  }

}
